import React, { useContext, useState, useEffect } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import { Formik, Field } from "formik";
import {
  faPencilAlt,
  faTimes,
  faTrashAlt,
} from "@fortawesome/pro-light-svg-icons";
import { get } from "lodash";
import { isNullOrUndefined } from "@microsoft/applicationinsights-core-js";
import {
  ManagePlanLayout,
  FieldButtonGroup,
  FieldMultiSelectButtonGroup,
  SearchableList,
  FieldDropSide,
  FieldInputNumber,
  WarningModal,
  LoaderWrapper,
} from "../../../components";
import {
  FLOW_TYPES,
  getPathWithParam,
  managePlanFormNames,
  formFields,
  toOptionValuesFromMapper,
  OPTIONS_DATA_MAPPER,
  ROUTES,
  MANAGE_PLAN_ROUTES,
  clearFieldValues,
  getAdvancedPathWithParam,
} from "../../../utils";
import {
  createPlanStore,
  setManagePlanToastInfo,
  setManagePlanFlow,
  setManagePageLevelData,
  savePlanDetailsAction,
} from "../../../contexts";
import { useRouterParams, useDeepEffect, useRequest } from "../../../abstracts";
import {
  getVestingRulesList,
  getRetirement,
  listVesting,
  saveRetirement,
  GetplanYos,
} from "../../../services";
const initialValues = {};

const ManageRetirementContainer = (props) => {
  const { history } = props;
  const { flow, planId } = useRouterParams();
  const { state, dispatch } = useContext(createPlanStore);
  const formName = managePlanFormNames.MANAGE_RETIREMENT;
  const fields = formFields[formName];

  const [vestingRulesList, setVestingRulesList] = useState([]);
  const [retirementId, setRetirementId] = useState(0);
  const [showPopUp, setShowPopUp] = useState(0);
  // const [earlyYOSRuleDisabled, setEarlyYOSRuleDisabled] = useState(false);
  // const [normalYOSRuleDisabled, setNormalYOSRuleDisabled] = useState(false);
  const { response: getPlanYosDataInVesting, loading: yosLoading } = useRequest(
    {
      method: GetplanYos,
      payload: planId,
      defaultResponse: [],
    }
  );
  useEffect(() => {
    if (planId) {
      getRetirement(parseInt(planId)).then((res) => {
        if (res.isSuccessful) {
          dispatch(
            setManagePlanFlow({
              retirement: get(res, "retirement", []),
            })
          );
        }
        setRetirementId(res?.retirement?.id ?? 0);
      });
      listVesting(parseInt(planId)).then((res) =>
        get(res, "isSuccessful", false)
          ? dispatch(
              setManagePlanFlow({
                vestings: get(res, "vestings", []),
              })
            )
          : null
      );
    }
  }, []);
  const apiData = get(state, "api.data", {});
  const retirementData = get(state, "retirement", {});
  useDeepEffect(() => {
    getVestingRulesList(planId).then((response) => {
      setVestingRulesList(
        response.map((val) => ({
          label: val.name,
          value: val.id,
        }))
      );
    });
  }, [vestingRulesList]);

  const vestingData = get(state, "vestings", []);
  const eligibilityData = get(apiData, "eligibilityRules", []);
  const vestinglen = vestingData?.filter(
    (_) => _.immediateVestingIndicator == true
  ).length;
  const eligibilitylen = eligibilityData?.filter(
    (_) =>
      (_.eligibilityRuleFor == 1 && _.immediateEligibility == true) ||
      _.eligibilityRuleFor == 2
  ).length;

  const goBack = () => {
    history.push(
      getPathWithParam({
        path: ROUTES.PLAN,
      })
    );
  };

  const onDeleteClick = () => {
    goBack();
  };

  // const vestingYOSCheck = (index) => {
  //   const yosValues = {};
  //   if (
  //     vestinglen != vestingData.length &&
  //     eligibilitylen == eligibilityData.length
  //   ) {
  //     if (index == 1) {
  //       yosValues[fields.earlyYOSRule] = 2;
  //       setEarlyYOSRuleDisabled(true);
  //     } else if (index == 2) {
  //       yosValues[fields.normalYOSRule] = 2;
  //       setNormalYOSRuleDisabled(true);
  //     } else if (index == 3 && isEdit === false) {
  //       yosValues[fields.earlyYOSRule] = 2;
  //       yosValues[fields.normalYOSRule] = 2;
  //     }
  //   } else if (
  //     vestinglen == vestingData.length &&
  //     eligibilitylen != eligibilityData.length
  //   ) {
  //     if (index == 1) {
  //       yosValues[fields.earlyYOSRule] = 1;
  //       setEarlyYOSRuleDisabled(true);
  //     } else if (index == 2) {
  //       yosValues[fields.normalYOSRule] = 1;
  //       setNormalYOSRuleDisabled(true);
  //     } else if (index == 3 && isEdit === false) {
  //       yosValues[fields.earlyYOSRule] = 1;
  //       yosValues[fields.normalYOSRule] = 1;
  //     }
  //   } else if (
  //     vestinglen == vestingData.length &&
  //     eligibilitylen == eligibilityData.length
  //   ) {
  //     if (index == 1) {
  //       yosValues[fields.earlyYOSRule] = null;
  //       setEarlyYOSRuleDisabled(true);
  //     } else if (index == 2) {
  //       yosValues[fields.normalYOSRule] = null;
  //       setNormalYOSRuleDisabled(true);
  //     } else if (index == 3 && isEdit === false) {
  //       yosValues[fields.earlyYOSRule] = null;
  //       yosValues[fields.normalYOSRule] = null;
  //     }
  //   }
  //   return yosValues;
  // };
  // useDeepEffect(() => {
  //   if ((isEdit && !isSave) == true) {
  //     setEarlyYOSRuleDisabled(true);
  //     setNormalYOSRuleDisabled(true);
  //   } else if (isEdit === false) {
  //     if (
  //       vestinglen != vestingData.length &&
  //       eligibilitylen == eligibilityData.length
  //     ) {
  //       setEarlyYOSRuleDisabled(true);
  //       setNormalYOSRuleDisabled(true);
  //     } else if (
  //       vestinglen == vestingData.length &&
  //       eligibilitylen != eligibilityData.length
  //     ) {
  //       setEarlyYOSRuleDisabled(true);
  //       setNormalYOSRuleDisabled(true);
  //     } else if (
  //       vestinglen == vestingData.length &&
  //       eligibilitylen == eligibilityData.length
  //     ) {
  //       setEarlyYOSRuleDisabled(true);
  //       setNormalYOSRuleDisabled(true);
  //     } else {
  //       setEarlyYOSRuleDisabled(false);
  //       setNormalYOSRuleDisabled(false);
  //     }
  //   }
  // }, [flow]);

  const buttons = [
    {
      onClick: goBack,
      label: "Cancel",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.ADD, FLOW_TYPES.SAVE],
    },
    {
      label: "Save",
      variant: "primary",
      type: "submit",
      flow: [FLOW_TYPES.ADD, FLOW_TYPES.SAVE],
    },
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      link: ROUTES.PLAN,
    },
    {
      label: "Edit",
      variant: "primary",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      onClick: () => {
        history.push(
          getAdvancedPathWithParam({
            path: MANAGE_PLAN_ROUTES.MANAGE_RETIREMENT,
            pathParam: [FLOW_TYPES.SAVE, planId],
          })
        );
      },
    },
  ];

  const onFormSubmit = (
    values,
    { setFieldError, setFieldTouched, setSubmitting }
  ) => {
    let objectKeys = Object.keys(values);
    let requestObject = {};
    objectKeys.forEach((key) => {
      if (values[key]) {
        requestObject[key] = values[key];
      }
    });
    saveRetirement({
      //...requestObject,
      ...values,
      planId: planId,
      earlyAgeYears: values[fields.earlyAgeYears],
      normalAgeYears: values[fields.normalAgeYears],
      // earlyYOSRule: values[fields.earlyYOSRule],
      // normalYOSRule: values[fields.normalYOSRule],
      earlyRetirementDateRule: values[fields.earlyRetirementDateRule],
      normalRetirementDateRule: values[fields.normalRetirementDateRule],
    }).then((response) => {
      if (response.isSuccessful) {
        dispatch(
          setManagePlanFlow({
            retirement: get(response, "retirement", []),
          })
        );
        history.push(
          getPathWithParam({
            path: MANAGE_PLAN_ROUTES.MANAGE_RETIREMENT,
            pathParam: [FLOW_TYPES.EDIT, planId],
          })
        );
        dispatch(
          setManagePlanToastInfo({
            showToast: true,
            toastMessage: "Data saved successfully",
          })
        );
      } else {
        setSubmitting(false);
        for (var i = 0; i < response.errorMessages.length; i++) {
          var _ = response.errorMessages[i];
          setFieldTouched(_.controlName, _.message);
          setFieldError(_.controlName, `${_.errorCode} : ${_.message}`);
        }
      }
    });
  };

  const isEdit = flow === FLOW_TYPES.EDIT;
  const isSave = flow === FLOW_TYPES.SAVE;
  const layoutHeader = "Retirement";
  return (
    <Formik
      initialValues={{
        ...initialValues,
        //[fields.normalRetirement]: 1,
        //[fields.earlyRetirement]: 1,
        // [fields.earlyvestingRule]:get(
        //   retirementData,
        //   fields.earlyvestingRule,
        //   []
        // )?.map((val) => val.vestingId),
        // [fields.normalvestingRule]:get(
        //   retirementData,
        //   fields.normalvestingRule,
        //   []
        // )?.map((val) => val.vestingId),
        ...retirementData,
        // ...vestingYOSCheck(3),
      }}
      onSubmit={onFormSubmit}
      enableReinitialize
      validateOnChange={false}
      validateOnBlur={false}
    >
      {(formProps) => {
        const {
          setFieldValue,
          values,
          handleChange,
          handleSubmit,
          setValues,
          setTouched,
          setSubmitting,
          ...rest
        } = formProps;

        // const handleEarlyRetirementTypeChange = (value) => {
        //   setValues({
        //     ...clearFieldValues({
        //       values,
        //       fieldsToClear: [fields.earlyServiceYears],
        //     }),
        //     [fields.earlyRetirement]: value,
        //   });
        //   setTouched({
        //     [fields.earlyServiceYears]: false,
        //   });
        // };
        const handleEarlyRetirementTypeChange = (value) => {
          if (value.includes(2)) {
            if (
              isNullOrUndefined(getPlanYosDataInVesting.planYOS) ||
              getPlanYosDataInVesting.planYOS?.isPlanYOSApplicable === false
            ) {
              setFieldValue(fields.earlyRetirement, []);
              setShowPopUp(true);
            } else if (
              getPlanYosDataInVesting.planYOS?.isPlanYOSApplicable === true
            ) {
              setValues({
                ...clearFieldValues({
                  values,
                  fieldsToClear: [
                    //fields.earlyServiceYears,
                    //fields.earlyAgeYears,
                    fields.earlyAgeMonths,
                    // fields.earlyYOSRule,
                    // fields.earlyvestingRule,
                    //fields.earlyParticipationYears,
                  ],
                }),
                [fields.earlyRetirement]: value,
                [fields.earlyAgeYears]: value.includes(1)
                  ? values[fields.earlyAgeYears]
                  : null,
                [fields.earlyServiceYears]: value.includes(2)
                  ? values[fields.earlyServiceYears]
                  : null,
                [fields.earlyParticipationYears]: value.includes(4)
                  ? values[fields.earlyParticipationYears]
                  : null,
                // ...vestingYOSCheck(1),
              });
              setTouched({
                [fields.earlyServiceYears]: false,
                [fields.earlyAgeYears]: false,
                [fields.earlyAgeMonths]: false,
                // [fields.earlyYOSRule]: false,
                // [fields.earlyvestingRule]: false,
                [fields.earlyParticipationYears]: false,
              });
            }
          } else {
            setValues({
              ...clearFieldValues({
                values,
                fieldsToClear: [
                  //fields.earlyServiceYears,
                  //fields.earlyAgeYears,
                  fields.earlyAgeMonths,
                  // fields.earlyYOSRule,
                  // fields.earlyvestingRule,
                  //fields.earlyParticipationYears,
                ],
              }),
              [fields.earlyRetirement]: value,
              [fields.earlyAgeYears]: value.includes(1)
                ? values[fields.earlyAgeYears]
                : null,
              [fields.earlyServiceYears]: value.includes(2)
                ? values[fields.earlyServiceYears]
                : null,
              [fields.earlyParticipationYears]: value.includes(4)
                ? values[fields.earlyParticipationYears]
                : null,
              // ...vestingYOSCheck(1),
            });
            setTouched({
              [fields.earlyServiceYears]: false,
              [fields.earlyAgeYears]: false,
              [fields.earlyAgeMonths]: false,
              // [fields.earlyYOSRule]: false,
              // [fields.earlyvestingRule]: false,
              [fields.earlyParticipationYears]: false,
            });
          }
        };

        const handleNormalRetirementTypeChange = (value) => {
          if (value.includes(2)) {
            if (
              isNullOrUndefined(getPlanYosDataInVesting.planYOS) ||
              getPlanYosDataInVesting.planYOS?.isPlanYOSApplicable === false
            ) {
              setFieldValue(fields.normalRetirement, []);
              setShowPopUp(true);
            } else if (
              getPlanYosDataInVesting.planYOS?.isPlanYOSApplicable === true
            ) {
              setValues({
                ...clearFieldValues({
                  values,
                  fieldsToClear: [
                    // fields.normalServiceYears,
                    //fields.normalAgeYears,
                    fields.normalAgeMonths,
                    // fields.normalYOSRule,
                    fields.normalvestingRule,
                    //fields.normalParticipationYears,
                  ],
                }),
                [fields.normalRetirement]: value,
                [fields.normalAgeYears]: value.includes(1)
                  ? values[fields.normalAgeYears]
                  : null,
                [fields.normalServiceYears]: value.includes(2)
                  ? values[fields.normalServiceYears]
                  : null,
                [fields.normalParticipationYears]: value.includes(4)
                  ? values[fields.normalParticipationYears]
                  : null,
                // ...vestingYOSCheck(2),
              });
              setTouched({
                [fields.normalServiceYears]: false,
                [fields.normalAgeYears]: false,
                [fields.normalAgeMonths]: false,
                // [fields.normalYOSRule]: false,
                // [fields.normalvestingRule]: false,
                [fields.normalParticipationYears]: false,
              });
            }
          } else {
            setValues({
              ...clearFieldValues({
                values,
                fieldsToClear: [
                  // fields.normalServiceYears,
                  //fields.normalAgeYears,
                  fields.normalAgeMonths,
                  // fields.normalYOSRule,
                  fields.normalvestingRule,
                  //fields.normalParticipationYears,
                ],
              }),
              [fields.normalRetirement]: value,
              [fields.normalAgeYears]: value.includes(1)
                ? values[fields.normalAgeYears]
                : null,
              [fields.normalServiceYears]: value.includes(2)
                ? values[fields.normalServiceYears]
                : null,
              [fields.normalParticipationYears]: value.includes(4)
                ? values[fields.normalParticipationYears]
                : null,
              // ...vestingYOSCheck(2),
            });
            setTouched({
              [fields.normalServiceYears]: false,
              [fields.normalAgeYears]: false,
              [fields.normalAgeMonths]: false,
              // [fields.normalYOSRule]: false,
              // [fields.normalvestingRule]: false,
              [fields.normalParticipationYears]: false,
            });
          }
        };
        return (
          <LoaderWrapper isLoading={yosLoading}>
            <Form
              autoComplete="off"
              className="h-100"
              onSubmit={handleSubmit}
              validated={rest.submitCount > 0}
            >
              <ManagePlanLayout
                layoutHeader={layoutHeader}
                buttons={buttons}
                pageFlow={flow}
              >
                <Row>
                  <Col>
                    <Field
                      label="Early Retirement"
                      name={fields.earlyRetirement}
                      options={toOptionValuesFromMapper(
                        OPTIONS_DATA_MAPPER.RETIREMENT_TYPE
                      )}
                      selectedValue={values[fields.earlyRetirement]}
                      onChange={handleEarlyRetirementTypeChange}
                      // onChange={(value) => {
                      //   setFieldValue(fields.earlyRetirement, value);
                      // }}
                      disabled={isEdit && !isSave}
                      //component={FieldButtonGroup}
                      component={FieldMultiSelectButtonGroup}
                      size="lg"
                      isRequired
                    />
                    {/* {[1].includes(values[fields.earlyRetirement]) && ( */}
                    {values[fields.earlyRetirement] &&
                      values[fields.earlyRetirement].includes(1) && (
                        <div className="d-flex">
                          <div style={{ marginRight: "18px" }}>
                            <Field
                              label="Age"
                              name={fields.earlyAgeYears}
                              type="number"
                              autoComplete="off"
                              value={values[fields.earlyAgeYears]}
                              onChange={handleChange}
                              component={FieldInputNumber}
                              disabled={isEdit && !isSave}
                              size="xxs"
                              hasSuggestion
                              suggestionDefaultText="years"
                              shouldDisplaySuggestion
                              min={0}
                              max={999}
                              isRequired
                            />
                          </div>
                          <Field
                            label=" "
                            name={fields.earlyAgeMonths}
                            type="number"
                            autoComplete="off"
                            value={values[fields.earlyAgeMonths]}
                            onChange={handleChange}
                            component={FieldInputNumber}
                            disabled={isEdit && !isSave}
                            size="xxs"
                            hasSuggestion
                            suggestionDefaultText="months"
                            shouldDisplaySuggestion
                            min={0}
                            max={99}
                            isRequired
                          />
                        </div>
                      )}
                    {/* {[2].includes(values[fields.earlyRetirement]) && ( */}
                    {values[fields.earlyRetirement] &&
                      values[fields.earlyRetirement].includes(2) && (
                        <div>
                          <Field
                            label="Service"
                            name={fields.earlyServiceYears}
                            type="number"
                            autoComplete="off"
                            value={values[fields.earlyServiceYears]}
                            onChange={handleChange}
                            component={FieldInputNumber}
                            disabled={isEdit && !isSave}
                            size="xxs"
                            hasSuggestion
                            suggestionDefaultText="years"
                            shouldDisplaySuggestion
                            min={0}
                            max={999}
                            isRequired
                          />
                          {/* <div className="display-flex mb-8">
                          <div className="marg-right-12 ft-12">
                            Years Of Service to be considered
                          </div>
                          <div className="tooltip-retirement">
                            <i class="fal fa-info-circle retirement-icon" />
                            <span className="tooltip-text">
                              When Plan Eligibility/Vesting rule is set to
                              Immediate, corresponding YOS option will be greyed
                              out
                            </span>
                          </div>
                        </div> */}

                          {/* <Field
                          size="md"
                          name={fields.earlyYOSRule}
                          //label={"Years Of Service to be considered"}
                          options={toOptionValuesFromMapper(
                            OPTIONS_DATA_MAPPER.YEARS_OF_SERVICE_OPTIONS
                          )}
                          selectedValue={values[fields.earlyYOSRule]}
                          value={values[fields.earlyYOSRule]}
                          onChange={(value) => {
                            setValues({
                              ...values,
                              [fields.earlyYOSRule]: value,
                            });
                          }}
                          component={FieldButtonGroup}
                          disabled={earlyYOSRuleDisabled}
                          isRequired
                        /> */}

                          {/* {values[fields.earlyYOSRule] === 2 ? (
                          <Field
                            label="Select Vesting Rule"
                            name={fields.earlyvestingRule}
                            value={values[fields.earlyvestingRule]}
                            disabled={isEdit && !isSave}
                            options={vestingRulesList}
                            popupContent={
                              <SearchableList
                                isNotTypeAhead
                                isRadio
                                selectedValue={values[fields.earlyvestingRule]}
                                label="Select"
                                options={vestingRulesList}
                                onSelect={(value) =>
                                  setFieldValue(fields.earlyvestingRule, value)
                                }
                              />
                            }
                            component={FieldDropSide}
                            onChange={handleChange}
                            size="md"
                            isRequired
                          />
                        ) : null} */}
                        </div>
                      )}

                    {/* {[3].includes(values[fields.earlyRetirement]) && ( */}
                    {values[fields.earlyRetirement] &&
                      values[fields.earlyRetirement].includes(4) && (
                        <Field
                          label="Participation"
                          name={fields.earlyParticipationYears}
                          type="number"
                          autoComplete="off"
                          value={values[fields.earlyParticipationYears]}
                          onChange={handleChange}
                          component={FieldInputNumber}
                          disabled={isEdit && !isSave}
                          size="xxs"
                          hasSuggestion
                          suggestionDefaultText="years"
                          shouldDisplaySuggestion
                          min={1}
                          max={99}
                          isRequired
                        />
                      )}

                    <Field
                      label="Early Retirement Date"
                      name={fields.earlyRetirementDateRule}
                      value={values[fields.earlyRetirementDateRule]}
                      disabled={isEdit && !isSave}
                      options={toOptionValuesFromMapper(
                        OPTIONS_DATA_MAPPER.RETIREMENT_DATE_OPTIONS
                      )}
                      popupContent={
                        <SearchableList
                          isNotTypeAhead
                          isRadio
                          selectedValue={values[fields.earlyRetirementDateRule]}
                          label="Select an Early Retirement Date"
                          options={toOptionValuesFromMapper(
                            OPTIONS_DATA_MAPPER.RETIREMENT_DATE_OPTIONS
                          )}
                          onSelect={(value) =>
                            setFieldValue(fields.earlyRetirementDateRule, value)
                          }
                        />
                      }
                      component={FieldDropSide}
                      size="lg"
                      isRequired
                    />
                    <div className="line-separator"></div>
                    <Field
                      label="Normal Retirement"
                      name={fields.normalRetirement}
                      options={toOptionValuesFromMapper(
                        OPTIONS_DATA_MAPPER.RETIREMENT_TYPE
                      )}
                      selectedValue={values[fields.normalRetirement]}
                      onChange={handleNormalRetirementTypeChange}
                      disabled={isEdit && !isSave}
                      //component={FieldButtonGroup}
                      component={FieldMultiSelectButtonGroup}
                      size="lg"
                      isRequired
                    />
                    {/* {[1].includes(values[fields.normalRetirement]) && ( */}
                    {values[fields.normalRetirement] &&
                      values[fields.normalRetirement].includes(1) && (
                        <div className="d-flex">
                          <div style={{ marginRight: "18px" }}>
                            <Field
                              label="Age"
                              name={fields.normalAgeYears}
                              type="number"
                              autoComplete="off"
                              value={values[fields.normalAgeYears]}
                              onChange={handleChange}
                              component={FieldInputNumber}
                              disabled={isEdit && !isSave}
                              size="xxs"
                              hasSuggestion
                              suggestionDefaultText="years"
                              shouldDisplaySuggestion
                              min={0}
                              max={999}
                              isRequired
                            />
                          </div>
                          <Field
                            label=" "
                            name={fields.normalAgeMonths}
                            type="number"
                            autoComplete="off"
                            value={values[fields.normalAgeMonths]}
                            onChange={handleChange}
                            component={FieldInputNumber}
                            disabled={isEdit && !isSave}
                            size="xxs"
                            hasSuggestion
                            suggestionDefaultText="months"
                            shouldDisplaySuggestion
                            min={0}
                            max={99}
                            isRequired
                          />
                        </div>
                      )}

                    {/* {[2].includes(values[fields.normalRetirement]) && ( */}
                    {values[fields.normalRetirement] &&
                      values[fields.normalRetirement].includes(2) && (
                        <div>
                          <Field
                            label="Service"
                            name={fields.normalServiceYears}
                            type="number"
                            autoComplete="off"
                            value={values[fields.normalServiceYears]}
                            onChange={handleChange}
                            component={FieldInputNumber}
                            disabled={isEdit && !isSave}
                            size="xxs"
                            hasSuggestion
                            suggestionDefaultText="years"
                            shouldDisplaySuggestion
                            min={0}
                            max={999}
                            isRequired
                          />

                          {/* <div className="display-flex mb-8">
                          <div className="marg-right-12 ft-12">
                            Years Of Service to be considered
                          </div>
                          <div className="tooltip-retirement">
                            <i class="fal fa-info-circle retirement-icon" />
                            <span className="tooltip-text">
                              When Plan Eligibility/Vesting rule is set to
                              Immediate, corresponding YOS option will be greyed
                              out
                            </span>
                          </div>
                        </div> */}

                          {/* <Field
                          size="md"
                          name={fields.normalYOSRule}
                          //label={"Years Of Service to be considered"}
                          options={toOptionValuesFromMapper(
                            OPTIONS_DATA_MAPPER.YEARS_OF_SERVICE_OPTIONS
                          )}
                          selectedValue={values[fields.normalYOSRule]}
                          value={values[fields.normalYOSRule]}
                          onChange={(value) => {
                            setValues({
                              ...values,
                              [fields.normalYOSRule]: value,
                            });
                          }}
                          component={FieldButtonGroup}
                          disabled={normalYOSRuleDisabled}
                          isRequired
                        /> */}

                          {/* {values[fields.normalYOSRule] === 2 ? (
                          <Field
                            label="Select Vesting Rule"
                            name={fields.normalvestingRule}
                            value={values[fields.normalvestingRule]}
                            disabled={isEdit && !isSave}
                            options={vestingRulesList}
                            popupContent={
                              <SearchableList
                                isNotTypeAhead
                                isRadio
                                selectedValue={values[fields.normalvestingRule]}
                                label="Select"
                                options={vestingRulesList}
                                onSelect={(value) =>
                                  setFieldValue(fields.normalvestingRule, value)
                                }
                              />
                            }
                            component={FieldDropSide}
                            onChange={handleChange}
                            size="md"
                            isRequired
                          />
                        ) : null} */}
                        </div>
                      )}
                    {/* {[3].includes(values[fields.normalRetirement]) && ( */}
                    {values[fields.normalRetirement] &&
                      values[fields.normalRetirement].includes(4) && (
                        <Field
                          label="Participation"
                          name={fields.normalParticipationYears}
                          type="number"
                          autoComplete="off"
                          value={values[fields.normalParticipationYears]}
                          onChange={handleChange}
                          component={FieldInputNumber}
                          disabled={isEdit && !isSave}
                          size="xxs"
                          hasSuggestion
                          suggestionDefaultText="years"
                          shouldDisplaySuggestion
                          min={1}
                          max={99}
                          isRequired
                        />
                      )}
                    <Field
                      label="Normal Retirement Date"
                      name={fields.normalRetirementDateRule}
                      value={values[fields.normalRetirementDateRule]}
                      disabled={isEdit && !isSave}
                      options={toOptionValuesFromMapper(
                        OPTIONS_DATA_MAPPER.NORMAL_RETIREMENT_DATE_OPTIONS
                      )}
                      popupContent={
                        <SearchableList
                          isNotTypeAhead
                          isRadio
                          label="Select a Normal Retirement Date"
                          selectedValue={
                            values[fields.normalRetirementDateRule]
                          }
                          options={toOptionValuesFromMapper(
                            OPTIONS_DATA_MAPPER.NORMAL_RETIREMENT_DATE_OPTIONS
                          )}
                          onSelect={(value) =>
                            setFieldValue(
                              fields.normalRetirementDateRule,
                              value
                            )
                          }
                        />
                      }
                      component={FieldDropSide}
                      size="lg"
                      isRequired
                    />
                  </Col>
                </Row>
                <WarningModal show={showPopUp}>
                  <div className="remove-text">
                    <p>
                      Years of Service has not been configured in the plan.
                      Please configure Years of service from the Left menu to
                      set up retirement service criteria.
                    </p>
                    <Button
                      className="cancel-btn"
                      onClick={() => setShowPopUp(false)}
                    >
                      Ok
                    </Button>
                  </div>
                </WarningModal>
              </ManagePlanLayout>
            </Form>
          </LoaderWrapper>
        );
      }}
    </Formik>
  );
};

export default ManageRetirementContainer;
